var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4710_21622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 13.25C16.5873 13.25 16.2498 13.5875 16.2498 14V20C16.2498 20.4125 16.5873 20.75 16.9998 20.75C17.4123 20.75 17.7498 20.4125 17.7498 20V14C17.7498 13.5875 17.4123 13.25 16.9998 13.25ZM20.8548 15.395C20.5623 15.6875 20.5698 16.145 20.8473 16.4375C21.6948 17.3375 22.2198 18.5375 22.2498 19.865C22.3173 22.7375 19.9398 25.2125 17.0673 25.2425C14.1348 25.2875 11.7498 22.925 11.7498 20C11.7498 18.62 12.2823 17.3675 13.1523 16.43C13.4298 16.1375 13.4298 15.68 13.1448 15.395C12.8448 15.095 12.3573 15.1025 12.0723 15.41C10.9848 16.565 10.3023 18.1025 10.2498 19.805C10.1448 23.465 13.1223 26.63 16.7823 26.7425C20.6073 26.8625 23.7498 23.795 23.7498 19.9925C23.7498 18.215 23.0598 16.61 21.9348 15.41C21.6498 15.1025 21.1548 15.095 20.8548 15.395Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4710_21622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(8 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnable);
export default __webpack_public_path__ + "static/media/enable.4455293836ac39ef7dbf76ec3c8df07e.svg";
export { ForwardRef as ReactComponent };